import jQuery from 'jquery';
import ScrollMagic from 'scrollmagic';
import {TweenLite, Power2} from 'gsap';
import { isMobile } from 'utils';

export default () => {
  const controller = new ScrollMagic.Controller();

  if (jQuery('#first-screen').length) {
    TweenLite.from('.header-text', 0.2, {
      transform: 'translateY(70px)',
      opacity: 0,
      ease: Power2.easeOut,
      delay: 0.7
    });
    TweenLite.from('.red-line', 0.2, {
      transform: 'translateY(70px)',
      opacity: 0,
      ease: Power2.easeOut,
      delay: 0.8
    });

    TweenLite.from('.subheader-text', 0.2, {
      transform: 'translateY(70px)',
      opacity: 0,
      ease: Power2.easeOut,
      delay: 0.9
    });
  }

  if (jQuery('.vacancy, .portfolio').length) {
    TweenLite.from('.vacancy, .portfolio', 0.8, {
      transform: 'translateY(1000px)',
      ease: Power2.easeOut,
      delay: 0.3
    });
  }

  if (jQuery('#about-screen').length) {
    const timeline = new TimelineMax();
    timeline.from('#about-screen h2', 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut})
        .from('#about-screen hr', 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut}, 0.1)
        .from('#about-screen .service:eq(0)', 0.3, {
          transform: 'translateY(70px)',
          opacity: 0,
          ease: Power2.easeOut
        }, 0.2)
        .from('#about-screen .service:eq(1)', 0.3, {
          transform: 'translateY(70px)',
          opacity: 0,
          ease: Power2.easeOut
        }, 0.3)
        .from('#about-screen .service:eq(2)', 0.3, {
          transform: 'translateY(70px)',
          opacity: 0,
          ease: Power2.easeOut
        }, 0.4);

    new ScrollMagic.Scene({
      triggerElement: '#about-screen',
      reverse: false
    })
        .setTween(timeline)
        .addTo(controller);
    // .addIndicators();
  }

  // Portfolio block
  jQuery('.portfolio').each(function (index, element) {
    const el = jQuery(element);
    const thumbs = jQuery('.thumbs img', element);
    const timeline = new TimelineMax();

    timeline
        .from(thumbs[0], 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut})
        .from(thumbs[1], 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut}, 0.1)
        .from(thumbs[2], 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut}, 0.2)
        .from(thumbs[3], 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut}, 0.3)
        .from(jQuery('.title', el), 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut}, 0.4)
        .from(jQuery('.text', el), 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut}, 0.5)
        .from(jQuery('.link', el), 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut}, 0.6);

    new ScrollMagic.Scene({
      triggerElement: '#' + el.attr('id'),
      reverse: false
    })
        .setTween(timeline)
        .addTo(controller);
    // .addIndicators();
  });

  // Portfolio block
  jQuery('.comment').each(function (index, element) {
    const el = jQuery(element);
    const timeline = new TimelineMax();

    timeline
        .from(jQuery('.avatar', el), 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut})
        .from(jQuery('.quote', el), 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut}, 0.1)
        .from(jQuery('.sign', el), 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut}, 0.2);

    new ScrollMagic.Scene({
      triggerElement: '#' + el.attr('id'),
      reverse: false
    })
        .setTween(timeline)
        .addTo(controller);
    // .addIndicators();
  });

  // About2
  if (jQuery('#about2-screen').length) {
    const timeline = new TimelineMax();
    timeline.from('#about2-screen .text', 0.3, {
      transform: 'translateY(70px)',
      opacity: 0,
      ease: Power2.easeOut
    });
    const scene = new ScrollMagic.Scene({
      triggerElement: '#about2-screen',
      reverse: false
    })
        .setTween(timeline)
        .addTo(controller);
    //.addIndicators();
  }

  // Num Slides (Vacancies)
  jQuery('.num-slide').each(function (index, element) {
    const el = jQuery(element);
    const timeline = new TimelineMax();

    timeline
        .from(jQuery ('.num', el), 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut})
        .from(jQuery ('h2', el), 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut}, 0.1)
        .from(jQuery ('.text, .vacancies', el), 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut}, 0.2);

    new ScrollMagic.Scene({
      triggerElement: '#' + el.attr('id'),
      reverse: false
    })
        .setTween(timeline)
        .addTo(controller);
    //.addIndicators();
  });

  // Path (if exists)
  jQuery('.path').each( function( index, element ) {
    var el = jQuery( element );
    var timeline = new TimelineMax();

    jQuery('.block', el).each(function(index, element){
      timeline.from( jQuery( element ), .3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut}, index * 0.1);
    });

    new ScrollMagic.Scene({
      triggerElement: '#' + el.attr('id'),
      reverse: false
    })
        .setTween(timeline)
        .addTo(controller);

  });

  // Header image
  jQuery('.header-img').each(function (index, element) {
    const el = jQuery(element);
    const timeline = new TimelineMax();

    timeline.from( jQuery( element ), .3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut}, index * 0.1);

    new ScrollMagic.Scene({
      triggerElement: '#' + el.attr('id'),
      reverse: false
    })
        .setTween(timeline)
        .addTo(controller);

  });

  // Stat Image
  jQuery('.stat-image').each(function( index, element) {
    var el = jQuery( element );
    var timeline = new TimelineMax();

    timeline.from( jQuery('.image', el), 0.3, {transform: 'translateY(70px)', opacity: 0, ease: Power2.easeOut});

    jQuery('.stat-block', el).each(function(index, element){
      if (!isMobile) {
        timeline.from(jQuery(element), 0.3, {

          transform: 'translateX(300px)',
          opacity: 0,
          ease: Power2.easeOut
        }, 0.1 + (index * 0.1));
      } else {
        timeline.from(jQuery(element), .3, {
          transform: 'translateY(70px)',
          opacity: 0,
          ease: Power2.easeOut
        }, 0.1 + (index * 0.1));
      }
    });

    new ScrollMagic.Scene({
      triggerElement: '#' + el.attr('id'),
      reverse: false
    })
        .setTween(timeline)
        .addTo(controller);
  });
};



// WEBPACK FOOTER //
// ./wordpress/wp-content/themes/foach/js/modules/animations.js